import { Layout } from '@/data/types/Layout';

export const getSiteMapPage = (): Layout => ({
	name: 'DoubleStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'SiteMap', id: 'site-map' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
